import { render, staticRenderFns } from "./BudgetDetail.vue?vue&type=template&id=265817fe&"
import script from "./BudgetDetail.vue?vue&type=script&lang=js&"
export * from "./BudgetDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports